import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Dialog } from 'primeng/dialog';
import { Select } from 'primeng/select';
import { Button } from 'primeng/button';
import { SharedModule } from 'primeng/api';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    selector: 'app-anomalia-motivo-dialog',
    standalone: true,
    imports: [DialogoPadraoDirective, FormsModule, Dialog, Select, Button, SharedModule],
    templateUrl: './anomalia-motivo.html',
    styleUrl: './anomalia-motivo.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
/** Diálogo de seleção do motivo de anomalia da biometria. */
export class AnomaliaMotivoDialogComponent {
    showDialog = model.required<boolean>();
    valorAtual = input<string>('');

    // Output responsável por enviar o dado para a Biometria
    escolhido = output<string>();
    cancelado = output<void>();

    readonly opcoes: string[] = ['Captura Normal', 'Estigma Profissional', 'Queimadura', 'Deformação Congênita', 'Outros'];

    readonly opcoesItems = this.opcoes.map((o) => ({ label: o, value: o }));
    selecionado: string = '';

    OnDialogShow(): void {
        const atual = (this.valorAtual() || '').trim();
        this.selecionado = atual || this.opcoes[0];
    }

    confirmar(): void {
        const value = this.selecionado || this.opcoes[0];
        this.escolhido.emit(value);
        this.showDialog.set(false);
    }

    hideDialog(): void {
        this.showDialog.set(false);
    }

    cancelar(): void {
        this.cancelado.emit();
        this.showDialog.set(false);
    }
}
